// console.info("userStore call");
import { defineStore } from "pinia";
const userStore = defineStore("user", {
    state: () => {
        return {
            token: "" as string | null,
            userInfo: {} as object | null,
            date: 0 as number,
        };
    },
    actions: {
        setInfo(userInfo: object | null) {
            this.userInfo = userInfo;
        },
        setToken(token: string | null) {
            this.token = token;
        },
        setDate(date: number){
            this.date = date
        }
    },
});

export default userStore;
